import allowedDocumentMimeTypes from 'constants/allowedDocumentMimeTypes';
import { extensionOnlyAllowlistAxa } from 'constants/extensionOnlyAllowlist';

import { fileTypeFromBuffer } from 'file-type';
import { isPlatformAXA } from './showDetails';

const getFileExtension = (filename: string): string =>
  filename.split('.').pop()?.toLowerCase() || '';

const isExtensionOnlyAllowedFile = (file: File): boolean => {
  if (!file || !isPlatformAXA) return false;

  const ext = getFileExtension(file.name);
  return !!ext && extensionOnlyAllowlistAxa.includes(ext as any);
};

const isBufferAllowedFile = async (file: File): Promise<boolean> => {
  try {
    const arrayBuffer = await file.arrayBuffer();
    const fileTypeResult = await fileTypeFromBuffer(
      new Uint8Array(arrayBuffer)
    );

    return (
      fileTypeResult !== undefined &&
      allowedDocumentMimeTypes.includes(fileTypeResult.mime)
    );
  } catch (error) {
    return false;
  }
};

export const isDocumentFileAllowed = async (file: File): Promise<boolean> => {
  try {
    if (isExtensionOnlyAllowedFile(file)) {
      return true;
    }
    return await isBufferAllowedFile(file);
  } catch {
    return false;
  }
};
